import { ApolloProvider, createApolloClient } from '@do/graphql-client';
import { WalrusGlobalStyle } from '@do/walrus';
import * as Sentry from '@sentry/react';
import React from 'react';
import App from './App';
import { APOLLO_CLIENT_NAME } from './constants';

import './assets/overwrite-base.css';

const client = createApolloClient({ name: APOLLO_CLIENT_NAME });

/**
 * Here we do not follow the same pattern of using `mount` from @do/seashell` because we can't wrap `<App />` in a `<Shell />` component.
 * Doing so would cause an infinite redirect because `<Shell />` requires that the user is authenticated.
 */
const Component = () => {
  React.useEffect(() => {
    Sentry.getGlobalScope().setContext('microfrontend', {
      dsn: process.env.REACT_APP_SENTRY_DSN!,
      release: process.env.REACT_APP_RELEASE!,
    });
  }, []);

  return (
    <>
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
      <WalrusGlobalStyle />
    </>
  );
};

export default { Component, version: 1 };
